import { useAuth } from "context/auth";
import PassCover from "icons/pass-cover";
import PassLogo from "icons/pass-logo";
import { QRCodeCanvas } from "qrcode.react";
import { invertTextColor, vcfText } from "utils";

function ApplePass({ design, values }) {
  const {
    backgroundColor,
    logoImage,
    stripImage,
    jobTitle,
    prefix,
    firstName,
    lastName,
    fullName,
    email,
    phone,
    phones,
    organisationName,
    companyURL,
    linkedInURL,
    socials,
    addresses,
    personalAccount,
  } = design;

  const isEnglish = (text) => {
    if (!text) return true;
    const cleanText = text.replace(/\s+/g, "").toLowerCase();
    return /[a-zA-Z]/g.test(cleanText);
  };

  const { currentUser } = useAuth();

  const vcf = vcfText({
  prefix,
  firstName,
  lastName,
  email,
  phone,
  phones: phones?.map((e) => ({
    type: (e?.type || "work").toLowerCase(),
    dialCode: e?.dialCode || "+966",
    value: e?.value || e?.number || e,
  })),
  jobTitle,
  organizationName: organisationName,

  // ✅ typed companyURL directly PassPreview se aa raha hai
  companyURL,

  linkedInURL,
  socials,
  addresses,
  personalAccount,
});

// console.log("🍎 Apple VCF OUTPUT =", vcf);


  return (
    <div className="tw-relative" style={{ maxWidth: "330px" }}>
      <div
        className="tw-visible tw-w-[330px] tw-shadow-lg tw-text-white tw-rounded-2xl"
        style={{ backgroundColor: backgroundColor }}
      >
        <div className="tw-flex tw-flex-col tw-h-full tw-justify-between tw-pb-6">
          <div className="tw-mt-3 tw-ml-3 tw-w-1/6">
            {logoImage ? (
              <img
                style={{ height: 40, objectFit: "contain" }}
                className="even:tw-hidden"
                src={logoImage}
                alt="Logo"
              />
            ) : (
              <div id="default-logo" className="tw-block tw-mt-3 tw-ml-3">
                <PassLogo color={invertTextColor(backgroundColor)} />
              </div>
            )}
          </div>
          <div className="tw-items-center tw-justify-center tw-overflow-hidden tw-flex tw-aspect-[1033/407] tw-my-[15px]">
            {stripImage ? (
              <img
                // class="even:tw-hidden tw-w-full"
                className="even:tw-hidden tw-w-full"
                src={stripImage}
                alt="Primary strip"
              />
            ) : (
              <span
                id="default-strip"
                className="tw-flex tw-items-center tw-px-6 tw-w-full  tw-aspect-[3/1]"
              >
                <div className="tw-mx-auto tw-w-2/3">
                  <PassCover color={invertTextColor(backgroundColor)} />
                </div>
              </span>
            )}
          </div>
          <div className="tw-mb-12">
            <div className="tw-px-6">
              <p
                className="tw-text-[12px] tw-uppercase"
                style={{
                  color: invertTextColor(backgroundColor),
                  textAlign: isEnglish(jobTitle) ? "left" : "right",
                }}
              >
                {jobTitle}&nbsp;
              </p>
              <p
                className="tw-text-2xl tw-font-extralight"
                style={{
                  color: invertTextColor(backgroundColor),
                  textAlign: isEnglish(fullName) ? "left" : "right",
                }}
              >
                {values?.prefix
                  ? `${values?.prefix || ""} ${firstName || ""} ${
                      lastName || ""
                    }`.trim()
                  : `${currentUser?.prefix || ""} ${firstName || ""} ${
                      lastName || ""
                    }`.trim()}
              </p>
            </div>
          </div>
          <div className="tw-bg-white tw-mx-auto tw-rounded-md tw-card-qrcode tw-max-w-[138px] tw-p-[5px]">
           <QRCodeCanvas value={vcf} viewBox="0 0 53 53" size={128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplePass;
